export default __webpack_public_path__ + "static/media/DavidImage.278c32bd.png";